import { RTU_ICONS } from '../../constants/rtuIcons';
import { FEATURE_FLAGS } from '../../config/featureFlags';

export type RowActionKey =
  | 'ping'
  | 'generateLicence'
  | 'uploadLicense'
  | 'reboot'
  | 'updateConfig'
  | 'updateDeployment'
  | 'rtuInfo'
  | 'downloadDebugLog'
  | 'downloadConfig'
  | 'downloadDeployment';

export type RowActionGroup = 'update' | 'download' | 'other';

export interface RowActionCatalogItem {
  key: RowActionKey;
  group: RowActionGroup;
  labelKey: string;
  icon: string;
  defaultPinned: boolean;
}

const BASE_ROW_ACTION_CATALOG: RowActionCatalogItem[] = [
  {
    key: 'updateConfig',
    group: 'update',
    labelKey: 'rtuActions.items.updateConfig',
    icon: RTU_ICONS.UPDATE_CONFIG,
    defaultPinned: false,
  },
  {
    key: 'updateDeployment',
    group: 'update',
    labelKey: 'rtuActions.items.updateDeployment',
    icon: RTU_ICONS.UPDATE_DEPLOYMENT,
    defaultPinned: false,
  },
  {
    key: 'uploadLicense',
    group: 'update',
    labelKey: 'rtuActions.items.uploadLicense',
    icon: RTU_ICONS.UPDATE_CONFIG,
    defaultPinned: false,
  },
  {
    key: 'reboot',
    group: 'other',
    labelKey: 'rtuActions.items.reboot',
    icon: RTU_ICONS.REBOOT,
    defaultPinned: true,
  },
  {
    key: 'downloadDebugLog',
    group: 'download',
    labelKey: 'rtuActions.items.downloadDebugLog',
    icon: RTU_ICONS.DEBUG_LOG,
    defaultPinned: false,
  },
  {
    key: 'downloadConfig',
    group: 'download',
    labelKey: 'rtuActions.items.downloadConfig',
    icon: RTU_ICONS.DOWNLOAD_CONFIG,
    defaultPinned: false,
  },
  {
    key: 'downloadDeployment',
    group: 'download',
    labelKey: 'rtuActions.items.downloadDeployment',
    icon: RTU_ICONS.DOWNLOAD_DEPLOYMENT,
    defaultPinned: false,
  },
  {
    key: 'ping',
    group: 'other',
    labelKey: 'rtuActions.items.ping',
    icon: RTU_ICONS.PING,
    defaultPinned: true,
  },
  {
    key: 'generateLicence',
    group: 'other',
    labelKey: 'rtuActions.items.generateLicence',
    icon: RTU_ICONS.DOWNLOAD_CONFIG,
    defaultPinned: false,
  },
];

export const ROW_ACTION_CATALOG: RowActionCatalogItem[] = FEATURE_FLAGS.rtuInfoAction
  ? [
      ...BASE_ROW_ACTION_CATALOG,
      {
        key: 'rtuInfo',
        group: 'other',
        labelKey: 'rtuActions.items.rtuInfo',
        icon: RTU_ICONS.INFO,
        defaultPinned: false,
      },
    ]
  : BASE_ROW_ACTION_CATALOG;

export const DEFAULT_PINNED_ROW_ACTIONS: RowActionKey[] = ROW_ACTION_CATALOG
  .filter((item) => item.defaultPinned)
  .map((item) => item.key);

export const ASSET_INLINE_ACTIONS: RowActionKey[] = ['ping', 'reboot'];
